@for (activeDialog of activeDialogs$ | async; track activeDialog) {
    <priva-dynamic-component-slot data-dynamic-slot [dynamicComponent]="activeDialog" />
}
